import { Component, Input, OnInit } from '@angular/core'
import { AuthService } from '@engineering11/auth-web'
import { User } from 'firebase/auth'
import { DeviceDetectorService, DeviceInfo } from 'ngx-device-detector'
import { IEnvironment } from '../../model/environment.model'
import { BrowserDetectionService } from '../../service/browser-detection.service'
import { LocalStorageService } from '../../service/local-storage.service'

interface IUserVM {
  uid?: string
  displayName?: string | null
  email?: string | null
  emailVerified?: boolean
  tenantId?: string | null
  providerData?: any
  metadata?: any
}
@Component({
  selector: 'application-about',
  templateUrl: './about.component.html',
  styleUrls: ['./about.component.css'],
})
export class AboutComponent implements OnInit {
  @Input()
  environment?: IEnvironment

  isMobile?: boolean
  deviceInfo?: DeviceInfo
  userFromAuth?: IUserVM
  userFromStorage?: any
  appVersion?: string
  showAuthUser = false
  showStorageUser = false
  constructor(
    private deviceService: DeviceDetectorService,
    private browserDetectionService: BrowserDetectionService,
    private authService: AuthService,
    private localStorageService: LocalStorageService
  ) {}

  ngOnInit(): void {
    this.appVersion = this.environment?.version
    this.isMobile = this.browserDetectionService.getIsMobile()
    this.deviceInfo = this.deviceService.getDeviceInfo()
    this.authService.user$.subscribe((u: User) => {
      this.userFromAuth = this.buildUserVM(u)
    })
    this.userFromStorage = this.localStorageService.getItem('user')
    this.userFromStorage.photoURL = undefined
  }

  toggleAuthUser() {
    this.showAuthUser = !this.showAuthUser
  }
  toggleStorageUser() {
    this.showStorageUser = !this.showStorageUser
  }

  buildUserVM(user: User): IUserVM {
    const userVM: IUserVM = {}

    userVM.uid = user.uid
    userVM.displayName = user.displayName
    userVM.email = user.email
    userVM.emailVerified = user.emailVerified
    userVM.tenantId = user.tenantId
    userVM.providerData = user.providerData
    userVM.metadata = user.metadata
    return userVM
  }
}
